import styled from 'styled-components';
import { Box, BoxProps } from '../Box/Box';

export const Row = styled(Box)<BoxProps>`
  display: flex;
  flex-wrap: wrap;
`;
